import SignUpPage from '@gameday/react-components/components/SignUpPage'
import withWidth from '@material-ui/core/withWidth'
import { useEffect } from 'react'
import { signUpMsgSuccess } from 'shared/copy'

import routes from '../../../../constants/routes/routes'
import { buildPath } from '../../../../utils/common'

const SignUp = ({
  signUp,
  history,
  eventLogo,
  landingPageLogo,
  orgLogo,
  formType,
  signUpMsg,
  isSubmitPending,
  width,
  setSignupMsg,
  recaptcha,
  hierarchyCountryCode,
}) => {
  useEffect(() => {
    setSignupMsg(undefined)
  }, [])

  return (
    // biome-ignore lint/complexity/noUselessFragments: TODO
    <>
      <SignUpPage
        title="Sign up for a new account"
        history={history}
        logo={formType === 'event' ? eventLogo : orgLogo || landingPageLogo}
        loginLink={buildPath(formType, routes.login.path, history)}
        handleSubmit={(...args) => {
          setSignupMsg({
            type: null,
            message: '',
          })
          recaptcha()
            .then(() => {
              signUp(...args)
            })
            .catch(() => {
              setSignupMsg({
                type: 'ReCAPTCHA',
                message: 'Abnormal action detected',
              })
            })
        }}
        signingUp={isSubmitPending}
        formSuccess={signUpMsg === signUpMsgSuccess ? signUpMsg : ''}
        formError={signUpMsg && signUpMsg !== signUpMsgSuccess ? signUpMsg : ''}
        onChange={() =>
          setSignupMsg({
            type: null,
            message: '',
          })
        }
        application={width !== 'xs' ? 'desktop' : 'mobile'}
        hierarchyCountryCode={hierarchyCountryCode}
      />
    </>
  )
}

SignUp.defaultProps = {
  signUpMsg: '',
}

export default withWidth()(SignUp)
